import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Money, Badge, statusTone, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Wallet } from "lucide-react";
import { toast } from "sonner";

export default function AdminWithdrawals() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/withdrawals").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const setStatus = async (w, status) => { await api.post(`/admin/withdrawals/${w.id}/status`, { status }); toast.success(`Withdrawal ${status}`); load(); };
  return (
    <div data-testid="admin-withdrawals">
      <PageHeader title="Withdrawal Requests" subtitle="Approve or reject seller withdrawals" />
      {items.length === 0 ? <EmptyState icon={Wallet} title="No withdrawal requests" /> : (
        <div className="bg-white border border-border rounded-lg overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-muted-foreground"><tr><th className="p-4">Seller</th><th className="p-4">Amount</th><th className="p-4">Method</th><th className="p-4">Details</th><th className="p-4">Status</th><th className="p-4">Action</th></tr></thead>
            <tbody>
              {items.map((w) => (
                <tr key={w.id} className="border-t border-border" data-testid={`wd-${w.id}`}>
                  <td className="p-4 font-medium text-navy">{w.seller_name}</td>
                  <td className="p-4 font-semibold"><Money amount={w.amount} /></td>
                  <td className="p-4 capitalize">{w.method}</td>
                  <td className="p-4 text-muted-foreground text-xs">{w.details?.upi || "-"}</td>
                  <td className="p-4"><Badge tone={statusTone(w.status)}>{w.status}</Badge></td>
                  <td className="p-4">
                    {can("withdrawals", "manage") && w.status === "pending" && (
                      <div className="flex gap-2">
                        <Button size="sm" className="bg-emerald-600 text-white" onClick={() => setStatus(w, "approved")} data-testid={`approve-wd-${w.id}`}>Approve</Button>
                        <Button size="sm" variant="outline" className="text-crimson" onClick={() => setStatus(w, "rejected")}>Reject</Button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
